<template>
  <tr>
    <td data-label="Reference #">
      <strong>
        {{ quote.reference }}
      </strong>
    </td>
    <td data-label="Status">
      <h5 class="my-0">
        <span class="badge" :class="'badge-' + status.label">
          {{ status.text }}
        </span>
      </h5>
    </td>
    <td data-label="Property Address">
      {{ quote.propertyAddress }}
    </td>
    <td data-label="Quote Type">
      {{ quote.ReportType.name }}
    </td>
    <td class="button-2 text-center">
      <template v-if="status.text !== 'Awaiting Quote'">
        <a class="my-2 btn btn-primary" :href="'https://roscon.s3.amazonaws.com/' + quote.QuotePdf.objectKey">
          <i class="fa fa-download" /> Download
        </a>
        <button class="my-2 btn btn-success">
          <i class="fa fa-check" /> Approve Quote
        </button>
      </template>
      <template v-else>
        <em class="text-muted">
          Roscon to quote by EOB {{ dueDate }}
        </em>
        <br/>
        <a class="my-2 btn btn-primary btn-sm" :href="'https://roscon.s3.amazonaws.com/' + quote.QuotePdf.objectKey">
          <i class="fa fa-download" /> Download Request
        </a>
      </template>
    </td>
  </tr>
</template>

<script>
import util from '@server/util'
export default {
  name: 'PropertyReportQuoteRequestRow',
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    dueDate () {
      return util.businessDays(2, moment(this.quote.createdAt)).format('DD/MM/YYYY')
    },
    quote () {
      return {
        QuotePdf: {},
        ReportType: {},
        ...this.object
      }
    },
    status () {
      if (!this.quote.request) {
        if (this.quote.approved) {
          return {
            text: 'Quote Approved',
            label: 'success'
          }
        } else {
          return {
            text: 'Quoted',
            label: 'info'
          }
        }
      } else {
        return {
          text: 'Awaiting Quote',
          label: 'danger'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/PropertyReportQuoteRequest.vue